import CardProviderIcon from '@/components/card-provider-icon';
import { formatCardNumber, resolveCardProvider, type CardLike } from '@/lib/format-card';
import { cn } from '@/lib/utils';
import type { MouseEvent, ReactNode } from 'react';

interface CardProviderLabelProps {
	card: CardLike;
	className?: string;
	numberClassName?: string;
	onClick?: (e: MouseEvent<HTMLElement>) => void;
	children?: ReactNode;
}

export default function CardProviderLabel({
	card,
	className,
	numberClassName,
	onClick,
	children,
}: CardProviderLabelProps) {
	const provider = resolveCardProvider(card);

	return (
		<span className={cn('inline-flex items-center gap-1.5 min-w-0', className)} onClick={onClick}>
			<CardProviderIcon provider={provider} />
			<span className={cn('break-all', numberClassName)}>{formatCardNumber(card)}</span>
			{children}
		</span>
	);
}
